import { render, staticRenderFns } from "./listInvoiceBranch.vue?vue&type=template&id=cb2fdab6"
import script from "./listInvoiceBranch.vue?vue&type=script&lang=js"
export * from "./listInvoiceBranch.vue?vue&type=script&lang=js"
import style0 from "./listInvoiceBranch.vue?vue&type=style&index=0&id=cb2fdab6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports